import { useEffect, useState } from "react";

/**
 * Ops dashboards the current user can see ("manufacturing" | "operations").
 * Returns null while loading. Admins get both from the API.
 */
export function useDashboardGrants(enabled = true): string[] | null {
  const [grants, setGrants] = useState<string[] | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    fetch("/api/me/dashboard-grants")
      .then((res) => (res.ok ? res.json() : { dashboards: [] }))
      .then((data) => {
        if (!cancelled) setGrants(data.dashboards ?? []);
      })
      .catch(() => {
        if (!cancelled) setGrants([]);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return enabled ? grants : [];
}
